import useDeviceType from "../Utiles/FindDevice";


export default function Predict({ data }) {
  const { image, name, description, text_placement_side } = data || {};
  const deviceType = useDeviceType()

  if (!data?.enabled) return null;


  const getTextAlignmentAndJustify = (side) => {
    switch (side) {
      case 'left':
        return { text: 'text-left', justify: 'justify-start' };
      case 'right':
        return { text: 'text-right', justify: 'justify-end' };
      case 'center':
        return { text: 'text-center', justify: 'justify-center' };
      default:
        return { text: deviceType === 'mobile' ? 'text-center' : 'text-left', justify: deviceType === 'mobile' ? 'justify-center' : 'justify-start' };
    }
  };

  const { text: currentTextAlignment, justify: currentJustify } = getTextAlignmentAndJustify(text_placement_side)



  // Determine alignment and positioning based on text_placement_side
  const getAlignment = () => {
    switch (text_placement_side) {
      case 'left':
        return 'items-start text-left';
      case 'right':
        return 'items-end text-right';
      case 'center':
      default:
        return 'items-center text-center';
    }
  };

  const getTextAlignment = () => {
    switch (text_placement_side) {
      case 'left':
        return 'text-left';
      case 'right':
        return 'text-right';
      case 'center':
      default:
        return 'text-center';
    }
  };

  const getBackgroundSize = () => {
        const width = window.innerWidth;
        
        if (deviceType === 'mobile') {
            if (width >= 428) {
                return '100% 250px';
            } else if (width >= 390) {
                return '100% 250px';
            } else {
                return '100% 250px';
            }
        }

        if(width >= 1440) {
            return '100% 700px';
        }
        else if(width >= 1024) {
            return '100% 600px';
        }
        else if (width >= 700) {
            return '100% 300px';
        }

        return '100% 580px';
    };

    const getContainerHeight = () => {
        const width = window.innerWidth;  
        
        if (deviceType === 'mobile') {
            if (width >= 428) {
                return 'h-[250px]';
            } else if (width >= 390) {
                return 'h-[250px]';
            } else {
                return 'h-[250px]';
            }
        }

        if (width >= 1440) {
            return 'h-[700px]';
        } else if (width >= 1024) {
            return 'h-[600px]';
        } else if (width >= 700) {
            return 'md:h-[300px] lg:h-[600px] xl:h-[700px] 2xl:h-[700px] h-[400px]';
        }

        return 'md:h-[600px] lg:h-[600px] xl:h-[700px] 2xl:h-[700px] h-[250px]';
    };

  return (
    <section
      className={`w-full relative overflow-hidden ${getContainerHeight()}`}
      style={{
        backgroundImage: image ? `url('${image}')` : undefined,
        backgroundSize: getBackgroundSize(),
        backgroundRepeat: 'no-repeat',
        height: window.innerWidth >= 3840 && '800px'
      }}
    >
      <div className={`w-[90%] md:w-[70%] mx-auto flex flex-col ${currentTextAlignment} relative z-10`}>
        <div className="py-6">
          <h2
            className={`${getTextAlignment()} laptop-l-min:text-[47px] laptop-min:text-[29px] text-[18px] md:text-[24px] font-[600] text-[${data?.title_color || '#000'}] -tracking-[1px] font-archivo`}
          >
            {name}
          </h2>
          <h6
            className={`mt-2 md:text-[18px] text-[14px] ${text_placement_side === 'center' ? 'mx-auto' : ''} ${currentTextAlignment} laptop-l-min:leading-[32px] laptop-min:leading-[23px] font-[500] text-[${data?.text_color || '#00000060'}] opacity-[60%] -tracking-[.5px] font-inter`}
          >
            {description}
          </h6>
        </div>
      </div>
      {image && (
        <div
          className="absolute inset-0 z-0"
          style={{
            pointerEvents: 'none',
          }}
        />
      )}
    </section>
  );
}
